import React from 'react';
import { Box } from '@material-ui/core';

const PageNotFound = () => {
  return <Box>Page not Found</Box>;
};

export default PageNotFound;
